import * as React from 'react';
import {View} from 'react-native';
import {AcceptorsFilter} from '../../shared/components/acceptorsFilter';
import Screen from '../../shared/components/screen';
import {CustomScrollView} from '../../shared/components/scrollView';
import {useStyles} from '../../shared/hooks/styles';
import {useAcceptorsResolver} from '../../shared/resolvers/acceptorsResolver';

export default () => {
  const styles = useStyles(({theme}) => ({
    container: {
      paddingBottom: theme.screen.bottomOffset,
    },
  }));
  useAcceptorsResolver();

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.container}>
          <AcceptorsFilter />
        </View>
      </CustomScrollView>
    </Screen>
  );
};
